// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_1niaf634PEZ55ByEwe_VYt_0","card-box":"wBfA_5rTIPfOZhnY0Mrp6_0","active":"Nb1b5lH4415rlAn7a46HB_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27e4376e","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.player/ui/game-states/LEGISLATING/policy-selector.vue
// module id = 200
// module chunks = 0